// The Premium payload the native widgets read (see WidgetLock.java). Kept free
// of Firebase imports so it can be unit-tested; the hook that sends it is in
// useWidgetPremium.js.

// `until` is the Premium expiry: the phone compares it with its own clock (plus
// a grace period) so a lapse locks the widgets even if the app is never opened.
export function widgetPremiumPayload(billing, now = Date.now()) {
  const until = Number(billing?.premiumExpiresAt) || 0;
  const premium = billing?.plan === 'premium' && until > now;
  return { premium, until: premium ? until : 0 };
}
